import type { ApiClient, IApiJsonRequest } from '../../ApiClient';
import type { IApiFontAwesomeGetSessionTokenResponseBody } from './ProvidersApi.types';

export class ProvidersApi {
  public constructor(private client: ApiClient) {}

  public async getFontAwesomeSessionToken(): Promise<IApiFontAwesomeGetSessionTokenResponseBody> {
    const request: IApiJsonRequest = {
      path: '/providers/fontawesome/sessionToken',
      method: 'post',
    };

    const data =
      await this.client.fetchJsonStandardized<IApiFontAwesomeGetSessionTokenResponseBody>(
        request,
      );

    return data;
  }
}
